import { Controller } from "@hotwired/stimulus"

// Reports the browser's IANA time zone so server-rendered dates follow the
// user's local day. Mounted on <body> for signed-in users. Does nothing when
// the user picked a zone manually (autoValue false) or when the detected zone
// already matches the stored one; a sessionStorage guard keeps it to one
// attempt per zone per session.
export default class extends Controller {
    static values = { zone: String, auto: Boolean }

    connect() {
        if (!this.autoValue) return

        let detected
        try {
            detected = Intl.DateTimeFormat().resolvedOptions().timeZone
        } catch (e) {
            return
        }
        if (!detected || detected === this.zoneValue) return
        // Guard only when a zone is already stored; with nothing stored
        // (fresh user or just reverted to Automatic) always report.
        if (this.zoneValue && sessionStorage.getItem("tz-reported") === detected) return

        let token = document.querySelector('meta[name="csrf-token"]')?.content
        fetch("/time_zone", {
            method: "PATCH",
            headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": token },
            body: JSON.stringify({ time_zone: detected })
        }).then((response) => {
            if (response.ok) sessionStorage.setItem("tz-reported", detected)
        }).catch(() => {})
    }
}
